import { getRequest } from '../services/requestHandler';
import { GripType } from '../models';

export const getGripTypes = async () => {
  const url = 'grip/getGripTypes?activeOnly=true';
  const response = await getRequest<GripType>('GetGripTypes', url);
  return response;
};
